import { render } from "./rend1a2.vue?vue&type=template&id=7cdcdfac"
import script from "./rend1a2.vue?vue&type=script&lang=js"
export * from "./rend1a2.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__